import React from 'react';

import * as Styled from './svg.styled';

export default function Outlogout({
  fill = "#25282B",
  width = "22",
  height = "22",
  viewBox = "0 0 22 22"
}) {

  const widthString = typeof width  === 'number' ? `${width}px` : width;
  const heightString = typeof height  === 'number' ? `${height}px` : height;

  return (
    <Styled.Svg
      width={widthString}
      height={heightString}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M16 17L21 12L16 7"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 12H9" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>

    </Styled.Svg>
  )
}